import { useFormContext } from 'react-hook-form';

import type { ExamCenterProctorRequestVerdictFormType } from './schema';

export const useExamCenterProctorRequestDetailsFormContext =
  useFormContext<ExamCenterProctorRequestVerdictFormType>;
